
/*
 * @Description: portal mutations type
 */

export enum PortalMutationTypes {
  SET_PORTAL_TOKEN = 'SET_PORTAL_TOKEN',
  SET_PORTAL_CURRENT_PAGE_ID = 'SET_PORTAL_CURRENT_PAGE_ID',
  SET_PORTAL_INFO = 'SET_PORTAL_INFO',
  SET_PORTAL_LOADING = 'SET_PORTAL_LOADING',
  SET_PORTAL_TITLE = 'SET_PORTAL_TITLE',
  SET_PORTAL_ISMOBILE = 'SET_PORTAL_ISMOBILE'
}
